var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCases = function SvgCases(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 34918"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4712",
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "#E1B400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4916_3694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40462",
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "#FFD52C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4916_3694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40461",
    d: "M5 22C5 16.4142 5 13.6213 5.78563 11.3761C7.1928 7.35464 10.3546 4.1928 14.3761 2.78563C16.6213 2 19.4142 2 25 2C30.5858 2 33.3787 2 35.6239 2.78563C39.6454 4.1928 42.8072 7.35464 44.2144 11.3761C45 13.6213 45 16.4142 45 22C45 27.5858 45 30.3787 44.2144 32.6239C42.8072 36.6454 39.6454 39.8072 35.6239 41.2144C33.3787 42 30.5858 42 25 42C19.4142 42 16.6213 42 14.3761 41.2144C10.3546 39.8072 7.1928 36.6454 5.78563 32.6239C5 30.3787 5 27.5858 5 22Z",
    fill: "#FFD52C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40456",
    x: 2,
    y: 17,
    width: 40,
    height: 2,
    fill: "#1D1F29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40457",
    d: "M2 16C2.55228 16 3 16.4477 3 17V19C3 19.5523 2.55228 20 2 20V16Z",
    fill: "#1D1F29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40458",
    d: "M42 20C41.4477 20 41 19.5523 41 19L41 17C41 16.4477 41.4477 16 42 16L42 20Z",
    fill: "#1D1F29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40460",
    d: "M29 16C29 14.8954 29.8954 14 31 14H32C33.1046 14 34 14.8954 34 16V20C34 21.1046 33.1046 22 32 22H31C29.8954 22 29 21.1046 29 20V16Z",
    fill: "#FFD52C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40461_2",
    d: "M10 16C10 14.8954 10.8954 14 12 14H13C14.1046 14 15 14.8954 15 16V20C15 21.1046 14.1046 22 13 22H12C10.8954 22 10 21.1046 10 20V16Z",
    fill: "#FFD52C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40460 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 12H32C34.2091 12 36 13.7909 36 16V20C36 22.2091 34.2091 24 32 24H31C28.7909 24 27 22.2091 27 20V16C27 13.7909 28.7909 12 31 12ZM31 14C29.8954 14 29 14.8954 29 16V20C29 21.1046 29.8954 22 31 22H32C33.1046 22 34 21.1046 34 20V16C34 14.8954 33.1046 14 32 14H31Z",
    fill: "#1D1F29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40460 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12H13C15.2091 12 17 13.7909 17 16V20C17 22.2091 15.2091 24 13 24H12C9.79086 24 8 22.2091 8 20V16C8 13.7909 9.79086 12 12 12ZM12 14C10.8954 14 10 14.8954 10 16V20C10 21.1046 10.8954 22 12 22H13C14.1046 22 15 21.1046 15 20V16C15 14.8954 14.1046 14 13 14H12Z",
    fill: "#1D1F29"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCases, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cases.7a9fe395.svg";
export { ForwardRef as ReactComponent };